import { ReplaySubject } from 'rxjs/ReplaySubject';
export function createMediaSubject(initialState) {
  var subject = new ReplaySubject(1);
  if (initialState instanceof Error) {
    subject.error(initialState);
  } else if (initialState) {
    subject.next(initialState);
  }
  return subject;
}